import React, { useEffect, useRef, useState } from 'react'
import Chaticon from '../../../../media/AI-banker/ic-chat.svg'
import { useIntl } from 'react-intl'
import AddChaticon from '../../../../media/AI-banker/ic-add-chat.svg'
import ThreadTitle from './shortenString'
import { Dropdown } from 'react-bootstrap'
import { DateTime } from 'luxon'
import { useAuth } from '../../auth'
import { deleteChatThread, updateChatThreadTitle } from '../core/_requests'
import { toast } from 'react-toastify'
import { DeleteConfirmationModal } from './DeleteConfirmationModal'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { removeNullFields } from '../../../core/_util'

export const SideAIChatMenu = ({
  setIsNewConversation,
  setChatsFromThread,
  setThreadId,
  setIsMessageSend,
  chatThreads,
  getAllThreads,
  setEditThreadId,
  editThreadId,
  isTitleRenaming,
  setIsTitleRenaming,
}: any) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { formatMessage } = useIntl()
  const dropdownRefMouse = useRef<HTMLDivElement>(null)
  const [showKebabMenu, setShowKebabMenu] = useState(false)
  const [showThread, setShowThread] = useState<string>()
  const { companyId, currentUser } = useAuth()
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [isDeleting, setIsDeleting] = useState<boolean>(false)
  const [selectedConversation, setSelectedConversation] = useState<string | null>(null)
  const [newTitle, setNewTitle] = useState<string>('')

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      handleUpdateTitle()
    }
  }

  // Handle selecting a conversation
  const handleSelectConversation = (index: string) => {
    setSelectedConversation(index)
  }

  // Toggle menu open/close
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  // Menu styles
  const menuStyle = {
    position: 'fixed',
    top: '0',
    right: isMenuOpen ? '0' : '-70%', // Adjust this to your desired menu width
    width: '70%',
    height: '100%',
    backgroundColor: '#f8f9fa',
    transition: 'right 0.5s ease',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
    zIndex: '1000',
  }

  const notchStyle = {
    position: 'fixed',
    top: '9%',
    right: isMenuOpen ? '70%' : '0px',
    zIndex: '1100',
    transition: 'right 0.5s ease',
    borderRadius: '4px 0 0 4px',
  }

  const groupThreadsByDate = (threads: any[]) => {
    const grouped: { [key: string]: any[] } = {}
    const now = DateTime.now()

    threads.forEach((thread) => {
      const threadDate = DateTime.fromISO(thread.lastMessageAt)

      // Calculate difference
      const diffInDays = Math.floor(now.diff(threadDate, 'days').days)

      // Determine the group key
      let groupKey = ''

      if (threadDate.hasSame(now, 'day')) {
        groupKey = 'Today'
      } else if (threadDate.hasSame(now.minus({ days: 1 }), 'day')) {
        groupKey = 'Yesterday'
      } else if (diffInDays <= 7) {
        groupKey = `${diffInDays} days ago`
      } else {
        // Handle dates older than 7 days
        const diffInMonths = Math.floor(now.diff(threadDate, 'months').months)
        if (diffInMonths < 12) {
          groupKey = `${diffInMonths} month${diffInMonths > 1 ? 's' : ''} ago`
        } else {
          const diffInYears = Math.floor(now.diff(threadDate, 'years').years)
          groupKey = `${diffInYears} year${diffInYears > 1 ? 's' : ''} ago`
        }
      }

      // Initialize group if not already
      if (!grouped[groupKey]) {
        grouped[groupKey] = []
      }

      // Add thread to the appropriate group
      grouped[groupKey].push(thread)
    })

    return grouped
  }

  const sortedDates = (groupedThreads: { [key: string]: any[] }) => {
    const dateOrder: { [key: string]: number } = {
      Today: 0,
      Yesterday: 1,
    }

    return Object.keys(groupedThreads).sort((a, b) => {
      const aOrder = dateOrder[a] !== undefined ? dateOrder[a] : Infinity
      const bOrder = dateOrder[b] !== undefined ? dateOrder[b] : Infinity

      // Sort "Today" and "Yesterday" first
      if (aOrder !== Infinity || bOrder !== Infinity) {
        return aOrder - bOrder
      }

      // Function to parse date key
      const parseDateKey = (key: string): DateTime => {
        const dateParts = key.split(' ')

        if (dateParts.length === 3) {
          // e.g., "4 days ago"
          const daysAgo = parseInt(dateParts[0], 10)
          return DateTime.now().minus({ days: daysAgo })
        } else if (dateParts.length === 4) {
          // e.g., "2 months ago" or "1 year ago"
          const value = parseInt(dateParts[0], 10)
          const unit = dateParts[1]
          if (unit === 'month' || unit === 'months') {
            return DateTime.now().minus({ months: value })
          } else if (unit === 'year' || unit === 'years') {
            return DateTime.now().minus({ years: value })
          }
        }
        // Handle unexpected cases by assuming the format is incorrect
        return DateTime.now() // Default to now
      }

      const aDate = parseDateKey(a)
      const bDate = parseDateKey(b)

      return bDate.toMillis() - aDate.toMillis()
    })
  }

  const groupedThreads = groupThreadsByDate(chatThreads)
  const sortedThreadDates = sortedDates(groupedThreads)

  console.log(sortedThreadDates, ' sortedThreadDates')
  console.log(groupedThreads, ' groupedThreads')

  const deleteChat = async () => {
    setIsDeleting(true)
    try {
      if (companyId) {
        const {
          data: { success, errors },
        }: any = await deleteChatThread(showThread, companyId)
        if (success) {
          getAllThreads()
          setModalOpen(false)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteChatThreadSuccessful,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                thread_id: showThread,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
              }),
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteChatThreadFailed,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                thread_id: showThread,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
                error: errors[0],
              }),
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsDeleting(false)
    }
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRefMouse.current && !dropdownRefMouse.current.contains(event.target as Node)) {
      setShowKebabMenu(false)
      setEditThreadId(null)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleUpdateTitle = async () => {
    setIsTitleRenaming(true)
    try {
      if (companyId) {
        let payload: any = {
          title: newTitle.trim(),
        }
        const {
          data: { success, errors },
        }: any = await updateChatThreadTitle(editThreadId, payload, companyId)
        if (success) {
          getAllThreads()
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateChatThreadTitleSuccessful,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                title: payload?.title,
                thread_id: editThreadId,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
              }),
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateChatThreadTitleFailed,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                title: payload?.title,
                thread_id: editThreadId,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
                error: errors[0],
              }),
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  console.log(showKebabMenu, ' showKebabMenu mobile')
  console.log(showThread, ' showThread mobile')

  return (
    <>
      <div className='d-block d-md-none'>
        <div
          style={notchStyle as React.CSSProperties}
          onClick={toggleMenu}
          className='p-4 cursor-pointer bg-white border border-1 border-primary'
        >
          <img src={Chaticon} alt='Chat Icon' />
        </div>

        <div style={menuStyle as React.CSSProperties}>
          <div className='d-flex bg-white p-4 flex-column h-100'>
            <div
              className='flex-grow-1 d-flex flex-column justify-content-end'
              style={{ height: 'calc(-180px + 95vh)', overflow: 'hidden' }}
            >
              <button
                className='btn btn-outline-primary btn-hover-primary btn-no-hover px-2 py-3 w-100 mb-4'
                onClick={() => {
                  setIsNewConversation(true)
                  setChatsFromThread([])
                  handleSelectConversation('')
                  setThreadId(null)
                  setIsMessageSend(false)
                }}
              >
                <div className='d-flex align-items-center justify-content-center'>
                  <img src={AddChaticon} alt='Add chat icon' />
                  <span className='font-size-13 ms-2'>
                    {formatMessage({ id: 'New Conversation' })}
                  </span>
                </div>
              </button>
              <div
                className='d-flex flex-column h-100'
                style={{ overflowY: 'scroll', overflowX: 'hidden' }}
              >
                {sortedThreadDates?.map((date: any) => (
                  <div key={date}>
                    <div className='font-size-13 text-dark mt-4 mb-2'>{date}</div>
                    {groupedThreads[date].map((thread: any, index: any) => (
                      <div key={thread.chatThreadId} className={`position-relative`}>
                        <div
                          onClick={() => {
                            handleSelectConversation(thread.chatThreadId)
                            setThreadId(thread.chatThreadId)
                            setIsNewConversation(false)
                          }}
                          className={`d-flex align-items-center py-4 px-2 gap-2 cursor-pointer justify-content-between w-100 ${selectedConversation?.trim() === thread.chatThreadId
                              ? 'selected-class'
                              : ''
                            }`}
                        >
                          <div
                            className={`d-flex gap-2 align-items-center justify-content-between w-100 ${selectedConversation?.trim() === thread.chatThreadId
                                ? 'selected-class'
                                : ''
                              }`}
                            onDoubleClick={() => {
                              setEditThreadId(thread.chatThreadId)
                              setNewTitle(thread.title)
                            }}
                          >
                            <div
                              className='d-flex align-items-center gap-2'
                              style={{ maxWidth: '80%' }}
                            >
                              <img src={Chaticon} alt='Chat icon' />
                              {editThreadId === thread.chatThreadId ? (
                                isTitleRenaming ? (
                                  formatMessage({ id: 'Renaming...' })
                                ) : (
                                  <input
                                    type='text'
                                    className='form-control'
                                    value={newTitle}
                                    onChange={(e) => setNewTitle(e.target.value)}
                                    onKeyDown={(e) => handleKeyDown(e)}
                                    // onBlur={() => setEditingThreadId(null)}
                                    autoFocus
                                  />
                                )
                              ) : (
                                <ThreadTitle title={thread.title} />
                              )}
                            </div>

                            <div>
                              <Dropdown.Toggle
                                className='bi bi-three-dots-vertical  me-1 p-1 px-3 py-2 bg-light text-dark'
                                onClick={() => {
                                  setShowKebabMenu(!showKebabMenu)
                                  setShowThread(thread.chatThreadId)
                                }}
                              ></Dropdown.Toggle>
                            </div>
                            {showKebabMenu && thread.chatThreadId === showThread && (
                              <div
                                ref={dropdownRefMouse}
                                className='card w-100px h-120px shadow rounded kebab-menu-dropdown-adjust cursor-pointer ms-auto'
                              >
                                <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items-color'>
                                  <div
                                    className='m-0'
                                    onClick={() => {
                                      setEditThreadId(thread.chatThreadId)
                                      setNewTitle(thread.title)
                                      setShowKebabMenu(!showKebabMenu)
                                    }}
                                  >
                                    {formatMessage({ id: 'Rename' })}
                                  </div>
                                </div>
                                <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items-color'>
                                  <div
                                    className='m-0 text-danger'
                                    onClick={() => setModalOpen(true)}
                                  >
                                    {formatMessage({ id: 'Delete' })}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeleteConfirmationModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        deleteChat={deleteChat}
        isDeleting={isDeleting}
      />
    </>
  )
}

export default SideAIChatMenu
